document.addEventListener("DOMContentLoaded", (event) => {
  if(window.location.href.includes('?register=success')){
    document.querySelector('.snippet-account-popup').classList.add('active-success');
    document.querySelector('body').classList.add('open-account');
  }
});
document.addEventListener("DOMContentLoaded",(event) => {
  if(document.querySelectorAll('.acc-click')) document.querySelectorAll('.acc-click').forEach(function(acClick){
    acClick.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('.snippet-account-popup').classList.remove('active-forgot','active-register');
      document.querySelector('.snippet-account-popup').classList.add('active-login');
      document.querySelector('body').classList.remove('open-menu');
      document.querySelector('body').classList.add('open-account');
    });
  });
  if(document.querySelectorAll('.overlay-box,.ac-close')) document.querySelectorAll('.overlay-box,.ac-close').forEach(function(acClose){
    acClose.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('.snippet-account-popup').classList.remove('active-success');
      document.querySelector('body').classList.remove('open-account');
      if(window.location.href.includes('?register=success')){
        let newUrl = window.location.href.split('?register=success')[0];
        window.history.replaceState(null, null, newUrl);
      }
    });
  });
  if(document.querySelector('.recover-btn a')) document.querySelector('.recover-btn a').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.snippet-account-popup').classList.add('active-forgot');
  })
  if(document.querySelector('.register-btn')) document.querySelector('.register-btn').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.snippet-account-popup').classList.replace('active-login','active-register');
  })
  if(document.querySelector('.already-acc a')) document.querySelector('.already-acc a').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.snippet-account-popup').classList.replace('active-register','active-login');
  })
  if(document.querySelector('.login-wrap') &&  document.querySelector('.forgot-wrap')){
    document.querySelector('.recover-btn-wrap a').addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('.main-login').classList.add('active-forgot');
    });
  }
})
function togglePasswordVisibility(passwordSelector, iconSelector){
  document.querySelectorAll(iconSelector).forEach(function(element){
    element.addEventListener('click', function(e){
      e.preventDefault();
      var passwordInput = this.parentElement.querySelector(passwordSelector);
      if(passwordInput.type === "password"){
        passwordInput.type = "text";
        element.classList.add('active');
      }else{
        passwordInput.type = "password";
        element.classList.remove('active');
      }
    });
  });
}
togglePasswordVisibility('.dis-reg-pass', '.reg-password-svg');